// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServiceModal_background__Sdz1Y {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ServiceModal_container__XdaJT {
  background-color: var(--color-white);
  border-radius: 1rem;
  width: 85vw;
  max-width: 100rem;
  min-height: 40vh;
  max-height: 65rem;
  color: var(--color-dark);
}
.ServiceModal_container__select__3ZUuM {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
@media only screen and (max-width: 43.75em) {
  .ServiceModal_container__select__3ZUuM {
    grid-template-columns: 100%;
  }
}
.ServiceModal_container__select__3ZUuM > * {
  padding: 2rem;
}
.ServiceModal_container__confirm__j1gsm {
  padding: 2rem;
  position: relative;
}

.ServiceModal_calendar__6cxlP {
  height: 100%;
  color: var(--color-white);
  background-color: var(--color-primary-4);
  border-radius: 1rem 0 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
}
@media only screen and (max-width: 43.75em) {
  .ServiceModal_calendar__6cxlP {
    border-radius: 1rem;
  }
}
.ServiceModal_calendar__img__L9Shu {
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background-color: var(--color-white);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ServiceModal_calendar__img__L9Shu img {
  width: 6.5rem;
  height: 6.5rem;
  object-fit: cover;
  border-radius: 50%;
}

.ServiceModal_rdp__today__UNSwj {
  color: var(--color-white);
  font-weight: 500;
}
.ServiceModal_rdp__selected__fLJuh {
  border-radius: 50%;
  background-color: var(--color-white);
  color: var(--color-dark);
}
.ServiceModal_rdp__chevron__CbJbl {
  fill: var(--color-white);
}
.ServiceModal_rdp__nav__E19oa {
  position: absolute;
  width: 100%;
}
.ServiceModal_rdp__nav__E19oa > :last-child {
  position: absolute;
  right: 0;
}
.ServiceModal_rdp__month__f8Usw {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.ServiceModal_close__3Lg-f {
  position: relative;
  width: 100%;
}
.ServiceModal_close__3Lg-f > * {
  position: absolute;
  right: 0;
  font-size: 3rem;
  cursor: pointer;
}

.ServiceModal_time__steps__xePWS {
  max-height: 50rem;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
@media only screen and (max-width: 43.75em) {
  .ServiceModal_time__steps__xePWS {
    max-height: 45rem;
  }
}
.ServiceModal_time__step__GPwoK {
  width: 90%;
  padding: 1rem;
  border: 1px solid var(--color-grey);
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: var(--color-dark);
}
.ServiceModal_time__step__GPwoK:hover {
  background-color: var(--color-grey);
}
.ServiceModal_time__type__TC1Dt {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ServiceModal_confirm__date__voApG {
  display: flex;
  gap: 1rem;
  align-items: center;
  width: 100%;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--color-grey);
  margin-bottom: 2rem;
  justify-content: space-between;
}
.ServiceModal_confirm__date__voApG > * {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.ServiceModal_confirm__date__voApG > :first-child {
  color: var(--color-primary);
}
.ServiceModal_confirm__info__sYV5U {
  padding: 1rem;
  border-radius: 1rem;
  width: 100%;
  display: flex;
  gap: 1rem;
  border: 1px solid var(--color-primary);
  background-color: var(--color-primary-9);
}
.ServiceModal_confirm__info__sYV5U > :first-child {
  color: var(--color-primary);
  margin-top: 4px;
}
.ServiceModal_confirm__buttons__YtONm {
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
  margin-top: 10rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ServiceModal/ServiceModal.module.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADD;;AAIA;EACC,oCAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AADD;AAGC;EACC,aAAA;EACA,8BAAA;AADF;AAGE;EAJD;IAKE,2BAAA;EAAD;AACF;AAEE;EACC,aAAA;AAAH;AAIC;EACC,aAAA;EACA,kBAAA;AAFF;;AAMA;EACC,YAAA;EACA,yBAAA;EACA,wCAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAHD;AAKC;EAVD;IAWE,mBAAA;EAFA;AACF;AAIC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAIE;EACC,aAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAFH;;AAQC;EACC,yBAAA;EACA,gBAAA;AALF;AAQC;EACC,kBAAA;EACA,oCAAA;EACA,wBAAA;AANF;AASC;EACC,wBAAA;AAPF;AAUC;EACC,kBAAA;EACA,WAAA;AARF;AAUE;EACC,kBAAA;EACA,QAAA;AARH;AAYC;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVF;;AAcA;EACC,kBAAA;EACA,WAAA;AAXD;AAaC;EACC,kBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AAXF;;AAgBC;EACC,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAbF;AAeE;EARD;IASE,iBAAA;EAZD;AACF;AAeC;EACC,UAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,wBAAA;AAbF;AAeE;EACC,mCAAA;AAbH;AAiBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAfF;;AAoBC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,0CAAA;EACA,mBAAA;EACA,8BAAA;AAjBF;AAmBE;EACC,aAAA;EACA,SAAA;EACA,mBAAA;AAjBH;AAoBE;EACC,2BAAA;AAlBH;AAsBC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,sCAAA;EACA,wCAAA;AApBF;AAsBE;EACC,2BAAA;EACA,eAAA;AApBH;AAwBC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,iBAAA;AAtBF","sourcesContent":["@import '../../assets/styles/variables/breakpoints';\n\n.background {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: rgba(#2a2828, 0.7);\n\tposition: fixed;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.container {\n\tbackground-color: var(--color-white);\n\tborder-radius: 1rem;\n\twidth: 85vw;\n\tmax-width: 100rem;\n\tmin-height: 40vh;\n\tmax-height: 65rem;\n\tcolor: var(--color-dark);\n\n\t&__select {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1fr;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tgrid-template-columns: 100%;\n\t\t}\n\n\t\t& > * {\n\t\t\tpadding: 2rem;\n\t\t}\n\t}\n\n\t&__confirm {\n\t\tpadding: 2rem;\n\t\tposition: relative;\n\t}\n}\n\n.calendar {\n\theight: 100%;\n\tcolor: var(--color-white);\n\tbackground-color: var(--color-primary-4);\n\tborder-radius: 1rem 0 0 1rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2rem;\n\talign-items: center;\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tborder-radius: 1rem;\n\t}\n\n\t&__img {\n\t\twidth: 7rem;\n\t\theight: 7rem;\n\t\tborder-radius: 50%;\n\t\tbackground-color: var(--color-white);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\timg {\n\t\t\twidth: 6.5rem;\n\t\t\theight: 6.5rem;\n\t\t\tobject-fit: cover;\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n}\n\n.rdp {\n\t&__today {\n\t\tcolor: var(--color-white);\n\t\tfont-weight: 500;\n\t}\n\n\t&__selected {\n\t\tborder-radius: 50%;\n\t\tbackground-color: var(--color-white);\n\t\tcolor: var(--color-dark);\n\t}\n\n\t&__chevron {\n\t\tfill: var(--color-white);\n\t}\n\n\t&__nav {\n\t\tposition: absolute;\n\t\twidth: 100%;\n\n\t\t& > :last-child {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t}\n\t}\n\n\t&__month {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tmargin-bottom: 1rem;\n\t}\n}\n\n.close {\n\tposition: relative;\n\twidth: 100%;\n\n\t& > * {\n\t\tposition: absolute;\n\t\tright: 0;\n\t\tfont-size: 3rem;\n\t\tcursor: pointer;\n\t}\n}\n\n.time {\n\t&__steps {\n\t\tmax-height: 50rem;\n\t\toverflow-y: scroll;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 1rem;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tmax-height: 45rem;\n\t\t}\n\t}\n\n\t&__step {\n\t\twidth: 90%;\n\t\tpadding: 1rem;\n\t\tborder: 1px solid var(--color-grey);\n\t\tborder-radius: 1rem;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\t\tcolor: var(--color-dark);\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-grey);\n\t\t}\n\t}\n\n\t&__type {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n}\n\n.confirm {\n\t&__date {\n\t\tdisplay: flex;\n\t\tgap: 1rem;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tpadding-bottom: 2rem;\n\t\tborder-bottom: 1px solid var(--color-grey);\n\t\tmargin-bottom: 2rem;\n\t\tjustify-content: space-between;\n\n\t\t& > * {\n\t\t\tdisplay: flex;\n\t\t\tgap: 1rem;\n\t\t\talign-items: center;\n\t\t}\n\n\t\t& > :first-child {\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n\n\t&__info {\n\t\tpadding: 1rem;\n\t\tborder-radius: 1rem;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tgap: 1rem;\n\t\tborder: 1px solid var(--color-primary);\n\t\tbackground-color: var(--color-primary-9);\n\n\t\t& > :first-child {\n\t\t\tcolor: var(--color-primary);\n\t\t\tmargin-top: 4px;\n\t\t}\n\t}\n\n\t&__buttons {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 1rem;\n\t\tjustify-content: space-between;\n\t\tmargin-top: 10rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `ServiceModal_background__Sdz1Y`,
	"container": `ServiceModal_container__XdaJT`,
	"container__select": `ServiceModal_container__select__3ZUuM`,
	"container__confirm": `ServiceModal_container__confirm__j1gsm`,
	"calendar": `ServiceModal_calendar__6cxlP`,
	"calendar__img": `ServiceModal_calendar__img__L9Shu`,
	"rdp__today": `ServiceModal_rdp__today__UNSwj`,
	"rdp__selected": `ServiceModal_rdp__selected__fLJuh`,
	"rdp__chevron": `ServiceModal_rdp__chevron__CbJbl`,
	"rdp__nav": `ServiceModal_rdp__nav__E19oa`,
	"rdp__month": `ServiceModal_rdp__month__f8Usw`,
	"close": `ServiceModal_close__3Lg-f`,
	"time__steps": `ServiceModal_time__steps__xePWS`,
	"time__step": `ServiceModal_time__step__GPwoK`,
	"time__type": `ServiceModal_time__type__TC1Dt`,
	"confirm__date": `ServiceModal_confirm__date__voApG`,
	"confirm__info": `ServiceModal_confirm__info__sYV5U`,
	"confirm__buttons": `ServiceModal_confirm__buttons__YtONm`
};
export default ___CSS_LOADER_EXPORT___;
